import { useFeatureFlagEnabled } from 'posthog-js/react';
import { useCallback, useRef, useState } from 'react';

import { NotificationType, showNotification } from '@Components/design-system/notification/notification';
import { fallsUnderInstant } from '@Modules/appointment/hooks/directional-engine/rules/initial';
import { useAppDispatch } from '@Redux/hooks';
import { ScheduleService } from '@Services';
import { FEATURE_FLAGS } from '@Utils/feature-flags';
import { LOG_ERROR } from '@Utils/logger';

import useAnasRouter from './anas-router';
import { Routes } from './anas-router/routes';

const useRescheduleInstantConsultation = () => {
  const dispatch = useAppDispatch();
  const router = useAnasRouter();
  const [isUpdatingAppointment, setIsUpdatingAppointment] = useState(false);
  const isUpdatingAppointmentRef = useRef(null);
  isUpdatingAppointmentRef.current = isUpdatingAppointment;
  const isInhouseMeetRollout = useFeatureFlagEnabled(FEATURE_FLAGS.INHOUSE_MEET_ROLLOUT) ?? false;
  const isInhouseMeetRolloutRef = useRef(isInhouseMeetRollout);
  isInhouseMeetRolloutRef.current = isInhouseMeetRollout;

  const rescheduleInstantConsultation = useCallback(
    (payload: { consultationId: string }) => {
      new Promise(async (resolve, reject) => {
        try {
          if (!fallsUnderInstant()) {
            showNotification(
              NotificationType.WARNING,
              'Instant Consultation is currently unavailable. Please feel free to try booking again between 11:00 AM - 8:00 PM IST.',
              3000,
            );
            router.push({ route: Routes.DASHBOARD });
            return;
          }
          setIsUpdatingAppointment(true);
          const result = await ScheduleService.UpdateInstantConsultation({
            consultationId: payload.consultationId,
          });
          if (result?.status === 201 && result?.data?.status === 'confirmed') resolve(result.data);
          else reject(result);
        } catch (error) {
          reject(error);
        }
      })
        .then((result: any) => {
          setTimeout(() => {
            router.push({
              route:
                isInhouseMeetRolloutRef.current && result?.appointment?.attributes?.isInstant
                  ? Routes.INHOUSE_MEET
                  : Routes.HMS,
              query: { appointment_id: result?.appointment?.id },
            });
            setIsUpdatingAppointment(false);
          }, 1000);
          return result;
        })
        .catch((error) => {
          LOG_ERROR('Error: useRescheduleInstantConsultation', error);
          setIsUpdatingAppointment(false);
        });
    },
    [dispatch],
  );

  return {
    rescheduleInstantConsultation,
    isUpdatingAppointment: isUpdatingAppointmentRef,
  };
};

export default useRescheduleInstantConsultation;
